import { TEST_IDS } from '@va/constants';
import { fontWeights, Paragraph } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { getInitials, stringToHslColor } from '@va/util/helpers';
import classNames from 'classnames';

type UserAvatarTypes = {
  text: string;
  isContributor?: boolean;
  bgColorClassName?: string;
  textColorClassName?: string;
};

const UserAvatar = ({ text, isContributor, bgColorClassName, textColorClassName }: UserAvatarTypes) => {
  const colorValue = stringToHslColor(text ?? 'N/A', '50', '60');
  return (
    <TooltipWrapper content={text} disabled={!text || isContributor}>
      <div
        data-testid={TEST_IDS.generic.avatar}
        className={classNames('w-12 h-12 rounded-full flex items-center justify-center text-white', bgColorClassName)}
        style={{ backgroundColor: bgColorClassName ? undefined : colorValue }}
      >
        <Paragraph weight={fontWeights.medium} className={classNames('cursor-default', textColorClassName)}>
          {getInitials(text ?? 'N/A')}
        </Paragraph>
      </div>
    </TooltipWrapper>
  );
};

export default UserAvatar;
